import { render } from "./EventsPage.vue?vue&type=template&id=2a46fdca"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=2a46fdca&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__